import NimbusModal from "./NimbusModal";

// Modal de confirmación genérico. `action` es el título y la etiqueta del botón
// de confirmar. La variante del header se infiere de la acción (rojo para
// eliminar/borrar, ámbar para el resto) y puede sobreescribirse con `variant`.
const ConfirmationModal = ({ isOpen, setIsOpen, handleAction, action = "", messages = [], variant }) => {
  const resolvedVariant = variant || (/eliminar|borrar/i.test(action) ? "danger" : "warning");

  const handleConfirmation = () => {
    setIsOpen(false);
    handleAction();
  };

  return (
    <NimbusModal
      isOpen={isOpen}
      variant={resolvedVariant}
      title={action}
      onRequestClose={() => setIsOpen(false)}
      styles={{
        content: { maxWidth: "30rem" },
        overlay: { zIndex: 9999 },
      }}
      onCancel={() => setIsOpen(false)}
      onConfirm={handleConfirmation}
      confirmText={action}
    >
      <div className="flex flex-col gap-y-2 items-center text-center min-w-[16rem]">
        {messages.map((message, idx) => (
          <span key={idx}>{message}</span>
        ))}
      </div>
    </NimbusModal>
  );
};

export default ConfirmationModal;
